import { render, staticRenderFns } from "./OverviewPanelBase.vue?vue&type=template&id=0a45b065"
import script from "./OverviewPanelBase.vue?vue&type=script&lang=js"
export * from "./OverviewPanelBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports